import React from "react";

export default function CheckMarkSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <rect width="18" height="18" fill="#DEF7EC" rx="9"></rect>
      <path
        fill="#0E9F6E"
        fillRule="evenodd"
        d="M13.695 5.705a.7.7 0 010 .99l-5.6 5.6a.7.7 0 01-.99 0l-2.8-2.8a.7.7 0 01.99-.99L7.6 10.81l5.105-5.105a.7.7 0 01.99 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
